import { render, staticRenderFns } from "./Minesweeper.vue?vue&type=template&id=3581a116&scoped=true&"
import script from "./Minesweeper.vue?vue&type=script&lang=js&"
export * from "./Minesweeper.vue?vue&type=script&lang=js&"
import style0 from "./Minesweeper.css?vue&type=style&index=0&id=3581a116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581a116",
  null
  
)

export default component.exports